// components/BatchTables/JobListTable.jsx
import React from "react";
import {
	Typography,
	TextField,
	FormControl,
	Select,
	MenuItem,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Button,
	Box,
	Pagination,
	CircularProgress 
} from "@mui/material";

const JobListTable = ({
	searchQuery,
	setSearchQuery,
	rowsPerPage,
	handleChangeRowsPerPage,
	anchorEl,
	closeFilter,
	filters,
	setFilters,
	filteredJobs,
	paginatedProcesses,
	handleJobClick,
	totalPages,
	page,
	handleChangePage,
	handleOpenModal,
	loading,
}) => {
	return (
		<>
			<Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
				View Batch Jobs
			</Typography>

			<TextField
				size="small"
				label="Search"
				value={searchQuery}
				onChange={(e) => setSearchQuery(e.target.value)}
				sx={{ flex: 1, mr: 2 }}
			/>

			<div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
				<Typography variant="body1">Rows per page:</Typography>
				<FormControl size="small">
					<Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
						<MenuItem value={10}>10</MenuItem>
						<MenuItem value={50}>50</MenuItem>
						<MenuItem value={100}>100</MenuItem>
					</Select>
				</FormControl>
			</div>


			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: "bold" }}>Job Name</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Short Description</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Execution Count</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Last Execution Status</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Job Execution Date</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Job Execution Start</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Job Execution Duration</TableCell>
							<TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{loading ? (
							<TableRow>
								<TableCell colSpan={8} align="center">
									<Box display="flex" alignItems="center" justifyContent="center" p={3}>
										<Typography variant="body2" mr={2}>Loading...</Typography>
										<CircularProgress size={24} />
									</Box>
								</TableCell>
							</TableRow>
						) : filteredJobs.length > 0 ? (
							paginatedProcesses.map((job, index) => (
								<TableRow key={index}>
									<TableCell>
										<Typography
											variant="body2"
											onClick={() => handleJobClick(job.batchName, job.exeCnt)}
											sx={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
										>
											{job.batchName}
										</Typography>
									</TableCell>
									<TableCell>{job.sdesc}</TableCell>
									<TableCell>{job.exeCnt}</TableCell>
									<TableCell>{job.lastExecStts}</TableCell>
									<TableCell>{job.lastExecDate}</TableCell>
									<TableCell>{job.lastExecStart}</TableCell>
									<TableCell>{job.lastExecDuration}</TableCell>
									<TableCell>
										<Button size="small" variant="outlined" onClick={() => handleOpenModal(job.batchName, job.param1)}>
											Run Job
										</Button>
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={8} align="center" sx={{ fontWeight: "bold" }}>
									No results found
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>

			<Box display="flex" justifyContent="right" mt={3}>
				<Pagination
					count={totalPages}
					page={page}
					onChange={handleChangePage}
					color="primary"
					showFirstButton
					showLastButton
				/>
			</Box>


		</>
	);
};

export default JobListTable;
